import React, { useEffect, useRef, useState } from "react";
import { PageHeader, Tooltip, Modal, Tag, Typography, Alert } from "antd";
import {
  SearchOutlined,
  FilePdfOutlined,
  FileExcelOutlined,
  SyncOutlined,
  DollarOutlined,
  BankOutlined,
  MailOutlined,
  BoxPlotOutlined,
  InfoCircleOutlined,
  ImportOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {
  ButtonItem,
  InputItem,
  SelectEscuelasItem,
  SegmentedItem,
  SubHeaderItem,
  DatePickerItem,
  TableItemDinamico,
  dineroDisabledMask,
} from "../../../Components/Items";
import { ORIGEN_CONFIG } from "../../../Components/VentaOnlineCard";
import ModalGenerarGuia from "./Components/ModalGenerarGuia";
import ModalGenerarGuiaManual from "./Components/ModalGenerarGuiaManual";
import ModalGenerarOCDropshipping from "./Components/ModalGenerarOCDropshipping";
import ModalPrevisualizarArchivos from "../../../Components/ModalPrevisualizarArchivos";
import ModalProgramarRecoleccion from "./Components/ModalProgramarRecoleccion";
import ModalConfirmarTransito from "./Components/ModalConfirmarTransito";
import ModalConfirmarEstadoConCorreo from "./Components/ModalConfirmarEstadoConCorreo";
import ModalConfirmarEmpaquetadoSucursal from "./Components/ModalConfirmarEmpaquetadoSucursal";
import ModalConfirmarPagoTransferencia from "./Components/ModalConfirmarPagoTransferencia";
import ModalConciliarTransferenciasExcel from "./Components/ModalConciliarTransferenciasExcel";
import ModalGenerarPickingLote from "./Components/ModalGenerarPickingLote";
import ModalEstadoGeneralPedido from "./Components/ModalEstadoGeneralPedido";
import ModalConfirmarEmpaquetadoLote from "./Components/ModalConfirmarEmpaquetadoLote";
import { STATUS_CONFIG } from "./statusPaqueteConfig";
import useVentasEcommerceAcciones, {
  determinarAccionesDisponibles,
  TIPO_ENVIO_LABELS,
  ORIGENES_FILTRO,
  ORIGENES_FLUJO_REDUCIDO,
} from "./useVentasEcommerceAcciones";

const { Text } = Typography;

// Color de botón (paleta de ButtonItem) por estado destino, para que el
// botón de "avanzar" use el mismo color que STATUS_CONFIG le da a esa
// columna en el Kanban.
const COLOR_PROP_POR_ESTADO = {
  1: "ambar",
  2: "cyan",
  3: "lila",
  4: "azul",
  5: "verde",
};

const ESTADOS_LEYENDA = Object.keys(STATUS_CONFIG).map((estado) => ({
  key: `estado-${estado}`,
  label: STATUS_CONFIG[estado].label,
  color: STATUS_CONFIG[estado].color,
}));

const ESTADOS_ACCION_FIJOS = [2, 3, 4, 5];

const VentasEcommerceTabla = (props) => {
  const {
    empresaId,
    headersToken,
    escuelaActivo,
    permisoConfirmarPago,
    history,
  } = props;

  const tableRef = useRef(null);

  const [ventasTabla, setVentasTabla] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [escuelaFiltroId, setEscuelaFiltroId] = useState(null);
  const [origenFiltro, setOrigenFiltro] = useState(null);
  const [estadoFiltro, setEstadoFiltro] = useState(null);
  const [fechaInicioValue, setFechaInicioValue] = useState(null);
  const [fechaFinValue, setFechaFinValue] = useState(null);
  const [textoFiltroInput, setTextoFiltroInput] = useState("");
  const [ventasParaRecoleccion, setVentasParaRecoleccion] = useState([]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalEmpaquetadoLoteVisible, setModalEmpaquetadoLoteVisible] = useState(false);
  const [pickingSeleccionVentaIds, setPickingSeleccionVentaIds] = useState(null);
  const [pickingSeleccionOrigenKey, setPickingSeleccionOrigenKey] = useState(null);

  const filtrosExternosActuales = () => ({
    escuelaFiltroId,
    origenFiltro,
    estadoFiltro,
    fechaInicio: fechaInicioValue ? fechaInicioValue.format("YYYY-MM-DD") : undefined,
    fechaFin: fechaFinValue ? fechaFinValue.format("YYYY-MM-DD") : undefined,
    textoFiltro: textoFiltroInput || undefined,
  });

  const onRefrescar = () => {
    tableRef.current?.updateExternalFilters(filtrosExternosActuales());
  };

  const acciones = useVentasEcommerceAcciones({
    empresaId,
    headersToken,
    history,
    onRefrescar,
  });
  const { modales } = acciones;

  useEffect(() => {
    acciones.consultarConfiguracionCorreos();
    acciones.consultarConfiguracionEnvioManual();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const consultarVentasTabla = (params) => {
    setLoading(true);
    setSelectedRowKeys([]);
    setSelectedRows([]);
    axios
      .post("ventasEcommerce/selectVentasTabla", { empresaId, ...params }, { headers: headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          setVentasTabla(res.data.data);
          setTotalRecords(res.data.totalRecords || 0);
        } else {
          setVentasTabla([]);
          setTotalRecords(0);
        }
      })
      .catch(() => setVentasTabla([]))
      .finally(() => setLoading(false));
  };

  const actualizarFiltrosExternos = (cambios) => {
    tableRef.current?.updateExternalFilters({ ...filtrosExternosActuales(), ...cambios });
  };

  const cerrarYRefrescar = (cerrar) => {
    cerrar();
    onRefrescar();
  };

  const abrirModalRecoleccion = (carrier, origenKey) => {
    axios
      .post("ventasEcommerce/selectVentas", { empresaId }, { headers: headersToken })
      .then((res) => {
        if (res.data.success === 2) setVentasParaRecoleccion(res.data.data);
      })
      .finally(() => {
        modales.setModalRecoleccionVisible(true);
        modales.setRecoleccionCarrier(carrier);
        modales.setRecoleccionOrigen(origenKey);
      });
  };
  const manejarAvanzar = (record) => {
    const envio = record.envio;
    const origenKey = envio.origen;
    const info = determinarAccionesDisponibles(record, envio, origenKey);
    if (!info) return;
    const estadoDestino = info.estadoDestino;

    if (estadoDestino === 2) {
      if (origenKey === "dropshipping_urrea") {
        modales.setModalOCVisible(true);
        modales.setSelectedVentaId(record._id);
        modales.setSelectedOrigenKey(origenKey);
      } else if (origenKey === "envio_manual") {
        modales.setModalGuiaManualVisible(true);
        modales.setSelectedVentaId(record._id);
        modales.setSelectedOrigenKey(origenKey);
        modales.setSoloActualizarEmpaquetado(false);
      } else if (origenKey === "entrega_sucursal") {
        modales.setModalEmpaqueSucursalVisible(true);
        modales.setSelectedVentaId(record._id);
        modales.setSelectedOrigenKey(origenKey);
        modales.setSoloActualizarEmpaquetado(false);
      } else {
        modales.setModalGuiaVisible(true);
        modales.setSelectedVentaId(record._id);
        modales.setSelectedOrigenKey(origenKey);
      }
      return;
    }

    if (estadoDestino === 3) {
      if (origenKey === "dropshipping_urrea") {
        Modal.confirm({
          title: "Confirmar paso a Orden de Entrega",
          content:
            "¿Confirmas que ya gestionaste la recolección de este paquete directamente en el portal del proveedor (Urrea)?",
          okText: "Sí, confirmar",
          cancelText: "Cancelar",
          onOk: () => acciones.actualizarEstadoBD(record._id, origenKey, estadoDestino),
        });
        return;
      }
      if (origenKey === "envio_manual" || origenKey === "entrega_sucursal") {
        const abrirModalEstadoCorreo = () => {
          modales.setModalEstadoCorreoVisible(true);
          modales.setEstadoCorreoVenta(record);
          modales.setEstadoCorreoEnvio(envio);
          modales.setEstadoCorreoOrigen(origenKey);
          modales.setEstadoCorreoNuevoEstado(estadoDestino);
        };
        if (info.advertenciaInsumosSinEmpaquetar > 0) {
          Modal.confirm({
            title: "⚠️ Insumos sin empaquetar",
            content: `Este pedido tiene ${info.advertenciaInsumosSinEmpaquetar} insumo(s) que aún no se han marcado como empaquetados. ¿Confirmas pasarlo a "Orden de entrega" de todas formas?`,
            okText: "Sí, continuar",
            cancelText: "Cancelar",
            onOk: abrirModalEstadoCorreo,
          });
        } else {
          abrirModalEstadoCorreo();
        }
        return;
      }
      abrirModalRecoleccion(envio.carrier, origenKey);
      return;
    }

    if (estadoDestino === 4) {
      if (info.requiereSalidaInventario) {
        Modal.confirm({
          title: "⚠️ Falta salida de inventario",
          content:
            "Para que el paquete pueda salir, primero debes confirmar la salida de los insumos en el sistema. ¿Ir a la pantalla de entrega?",
          okText: "Ir a Entregar Insumos",
          cancelText: "Cancelar",
          onOk: () => history.push("/panel/entregarInsumosVenta", { id: record._id }),
        });
        return;
      }
      if (origenKey === "envio_manual") {
        modales.setModalEstadoCorreoVisible(true);
        modales.setEstadoCorreoVenta(record);
        modales.setEstadoCorreoEnvio(envio);
        modales.setEstadoCorreoOrigen(origenKey);
        modales.setEstadoCorreoNuevoEstado(estadoDestino);
      } else {
        modales.setModalTransitoVisible(true);
        modales.setTransitoVenta(record);
        modales.setTransitoEnvio(envio);
        modales.setTransitoOrigenKey(origenKey);
      }
      return;
    }

    if (estadoDestino === 5) {
      if (info.requiereSalidaInventario) {
        Modal.confirm({
          title: "Falta salida de inventario",
          content:
            "Antes de marcar el pedido como entregado al cliente, confirma la salida de los insumos en el sistema. ¿Ir a la pantalla de entrega?",
          okText: "Ir a Entregar Insumos",
          cancelText: "Cancelar",
          onOk: () => history.push("/panel/entregarInsumosVenta", { id: record._id }),
        });
        return;
      }
      modales.setModalEstadoCorreoVisible(true);
      modales.setEstadoCorreoVenta(record);
      modales.setEstadoCorreoEnvio(envio);
      modales.setEstadoCorreoOrigen(origenKey);
      modales.setEstadoCorreoNuevoEstado(estadoDestino);
    }
  };

  const primeraSeleccionada = selectedRows[0] || null;
  const grupoSeleccion = primeraSeleccionada
    ? { origenKey: primeraSeleccionada.envio.origen, estado: primeraSeleccionada.envio.estadoPaquete }
    : null;
  const infoGrupo = primeraSeleccionada
    ? determinarAccionesDisponibles(primeraSeleccionada, primeraSeleccionada.envio, grupoSeleccion.origenKey)
    : null;
  const puedeEmpaquetarEnLote =
    infoGrupo?.estadoDestino === 2 && ORIGENES_FLUJO_REDUCIDO.includes(grupoSeleccion?.origenKey);

  // Feedback explícito de por qué la selección actual no tiene ninguna
  // acción de lote habilitada — antes solo se veían botones apagados sin
  // explicación.
  let mensajeSeleccionInvalida = null;
  if (selectedRows.length > 0) {
    if (!infoGrupo) {
      mensajeSeleccionInvalida =
        "Los pedidos seleccionados no tienen ninguna acción disponible en lote. ";
    } else if (infoGrupo.estadoDestino === 2 && selectedRows.length > 1 && !puedeEmpaquetarEnLote) {
      mensajeSeleccionInvalida =
        'El empaquetado en lote solo está disponible para envío manual y entrega en sucursal. Para bodega automática o dropshipping, procesa cada pedido por separado (requiere generar guía/orden de compra individual).';
    }
  }

  const limpiarSeleccion = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  const rowSelection = {
    selectedRowKeys,
    columnTitle: estadoFiltro && origenFiltro ? undefined : <span />,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
    getCheckboxProps: (record) => {
      if (record.envio.estadoPaquete === 0) {
        return { disabled: true };
      }
      if (!grupoSeleccion) return {};
      const coincide =
        record.envio.origen === grupoSeleccion.origenKey &&
        record.envio.estadoPaquete === grupoSeleccion.estado;
      return { disabled: !coincide };
    },
  };

  
  const manejarAvanzarSeleccion = (estadoDestino) => {
    if (selectedRows.length === 0 || !grupoSeleccion) return;

    if (selectedRows.length === 1) {
      manejarAvanzar(selectedRows[0]);
      return;
    }

    if (estadoDestino === 2) {
      setModalEmpaquetadoLoteVisible(true);
      return;
    }

    Modal.confirm({
      title: `¿Pasar ${selectedRows.length} pedido(s) a "${STATUS_CONFIG[estadoDestino].label}"?`,
      content:
        "Cada pedido se valida por separado; si alguno no cumple las reglas de negocio (insumos pendientes, etc.), se reportará como no actualizado sin afectar al resto.",
      okText: "Sí, continuar",
      cancelText: "Cancelar",
      onOk: async () => {
        const items = selectedRows.map((r) => ({ ventaId: r._id }));
        await acciones.actualizarEstadoLote(items, grupoSeleccion.origenKey, estadoDestino);
        limpiarSeleccion();
      },
    });
  };

  const confirmarEmpaquetadoLote = async (items) => {
    if (!grupoSeleccion) return;
    setModalEmpaquetadoLoteVisible(false);
    await acciones.actualizarEstadoLote(items, grupoSeleccion.origenKey, 2);
    limpiarSeleccion();
  };

  const abrirModalPicking = () => {
    if (selectedRows.length > 0) {
      setPickingSeleccionVentaIds([...new Set(selectedRows.map((r) => r._id))]);
      setPickingSeleccionOrigenKey(grupoSeleccion?.origenKey || null);
    } else {
      setPickingSeleccionVentaIds(null);
      setPickingSeleccionOrigenKey(null);
    }
    modales.setModalPickingLoteVisible(true);
  };

  const columns = [
    {
      title: "Folio",
      dataIndex: "serieNumero",
      key: "serieNumero",
      width: "9%",
      ellipsis: true,
    },
    {
      title: "Fecha",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      defaultSortOrder: "descend",
      render: (value) => moment(value).format("DD/MM/YY HH:mm"),
      width: "10%",
      align: "center",
      ellipsis: true,
    },
    {
      title: "Cliente eCommerce / Sistema",
      dataIndex: "clienteOnline",
      key: "clienteOnline",
      render: (value, record) => {
        const nombreEcommerce =
          [value?.nombre, value?.apellidoPaterno].filter(Boolean).join(" ") ||
          value?.email ||
          "-";
        const nombreSistema = record.nombreCliente || "-";
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", fontWeight: "bold" }}>{nombreEcommerce}</span>
            <span style={{ fontSize: "12px", color: "#666" }}>{nombreSistema}</span>
          </div>
        );
      },
      width: "18%",
      ellipsis: true,
    },
    {
      title: "Tipo de envío",
      dataIndex: "envio",
      key: "origen",
      render: (envio) => {
        const cfg = ORIGEN_CONFIG[envio.origen] || {};
        return <Tag color={cfg.antd}>{TIPO_ENVIO_LABELS[envio.origen] || envio.origen}</Tag>;
      },
      width: "11%",
      align: "center",
    },
    {
      title: "Estado",
      dataIndex: "envio",
      key: "estadoPaquete",
      render: (envio) => {
        const cfg = STATUS_CONFIG[envio.estadoPaquete] || {};
        return <Tag color={cfg.color}>{cfg.label || envio.estadoPaquete}</Tag>;
      },
      width: "13%",
      align: "center",
    },
    {
      title: "Total",
      dataIndex: "total",
      key: "total",
      sorter: true,
      render: (value) => dineroDisabledMask(value),
      width: "10%",
      align: "right",
      ellipsis: true,
    },
    {
      title: "Insumos entregados",
      dataIndex: "insumosEntregados",
      key: "insumosEntregados",
      align: "center",
      width: "12%",
      render: (_, record) => {
        const envio = record.envio;
        const esDropshipping = envio.origen === "dropshipping_urrea";
        const insumosEntrega = (record.insumos || []).filter(
          (ins) => !ins.servicio && !ins.libroVirtual && !!ins.dropshipping === esDropshipping,
        );
        if (insumosEntrega.length === 0) {
          const librosVirtuales = (record.insumos || []).filter((ins) => ins.libroVirtual);
          if (librosVirtuales.length > 0) {
            const pendiente = librosVirtuales.some((ins) => ins.libroVirtualError);
            return (
              <Tag color={pendiente ? "red" : "green"}>
                {pendiente ? "Código pendiente" : "Código asignado"}
              </Tag>
            );
          }
          return <Text type="secondary">N/A</Text>;
        }
        const entregados = insumosEntrega.filter(
          (ins) => (ins.entregado || 0) >= ins.cantidad,
        ).length;
        const completo = entregados === insumosEntrega.length;
        return (
          <Tag color={completo ? "green" : entregados > 0 ? "orange" : "red"}>
            {entregados} / {insumosEntrega.length}
          </Tag>
        );
      },
    },
    {
      title: "Acción",
      dataIndex: "accion",
      key: "accion",
      align: "center",
      width: "24%",
      render: (_, record) => {
        const envio = record.envio;
        const origenKey = envio.origen;
        const info = determinarAccionesDisponibles(record, envio, origenKey);
        const estaCancelada = record.estado === 0;
        const hayGuia = envio.guiaGenerada && envio.labelUrl;
        const mostrarBotonVerificarPago =
          record.estadoPago !== 3 && !!record.idPagoConekta && !estaCancelada;
        const mostrarBotonVerificarPagoMattilda =
          record.estadoPago !== 3 && !!record.idPagoMattilda && !estaCancelada;
        const mostrarBotonPagarManual =
          permisoConfirmarPago && record.estadoPago !== 3 && !estaCancelada;
        const mostrarBotonConfirmarTransferencia =
          permisoConfirmarPago &&
          record.pasarelaPagoOnline === "transferenciaFija" &&
          record.estadoPago !== 3 &&
          !estaCancelada;
        const mostrarBotonReenviarCorreo = !!record.clienteOnline?.email;
        const puedeSeguirEmpaquetando =
          (origenKey === "envio_manual" || origenKey === "entrega_sucursal") &&
          envio.estadoPaquete >= 2 &&
          (record.insumos || []).some(
            (ins) => !ins.servicio && !ins.dropshipping && !ins.libroVirtual && !ins.empaquetado,
          );

        return (
          <div className="venta-ecommerce-acciones">
            {!estaCancelada &&
              ESTADOS_ACCION_FIJOS.map((estado) => {
                const habilitado = !!info && info.estadoDestino === estado;
                return (
                  <Tooltip key={estado} title={STATUS_CONFIG[estado].label}>
                    <ButtonItem
                      size="small"
                      disabled={!habilitado}
                      icon={STATUS_CONFIG[estado]?.icon}
                      {...(habilitado ? { [COLOR_PROP_POR_ESTADO[estado] || "azul"]: true } : {})}
                      onClick={() => manejarAvanzar(record)}
                    />
                  </Tooltip>
                );
              })}
            {puedeSeguirEmpaquetando && (
              <Tooltip title="Seguir empaquetando (faltan insumos por marcar)">
                <ButtonItem
                  size="small"
                  naranja
                  icon={<BoxPlotOutlined />}
                  onClick={() => acciones.seguirEmpaquetando(record, envio)}
                />
              </Tooltip>
            )}
            {hayGuia && (
              <Tooltip title="Ver guía">
                <ButtonItem
                  size="small"
                  lima
                  icon={<FilePdfOutlined />}
                  onClick={() => acciones.abrirPrevisualizacionGuia(envio, record.serieNumero)}
                />
              </Tooltip>
            )}
            {mostrarBotonVerificarPago && (
              <Tooltip title="Verificar pago">
                <ButtonItem
                  size="small"
                  azul
                  icon={<SyncOutlined />}
                  onClick={() => acciones.verificarPagoVenta(record._id)}
                />
              </Tooltip>
            )}
            {mostrarBotonVerificarPagoMattilda && (
              <Tooltip title="Verificar pago (Mattilda)">
                <ButtonItem
                  size="small"
                  lila
                  icon={<SyncOutlined />}
                  onClick={() => acciones.verificarPagoMattildaVenta(record._id)}
                />
              </Tooltip>
            )}
            {mostrarBotonConfirmarTransferencia && (
              <Tooltip title="Confirmar transferencia">
                <ButtonItem
                  size="small"
                  cyan
                  icon={<BankOutlined />}
                  onClick={() => acciones.confirmarPagoTransferencia(record)}
                />
              </Tooltip>
            )}
            {mostrarBotonPagarManual && (
              <Tooltip title="Pagar manualmente">
                <ButtonItem
                  size="small"
                  verde
                  icon={<DollarOutlined />}
                  onClick={() => acciones.pagarManualmente(record._id)}
                />
              </Tooltip>
            )}
            {mostrarBotonReenviarCorreo && (
              <Tooltip title="Reenviar correo">
                <ButtonItem
                  size="small"
                  blanco
                  icon={<MailOutlined />}
                  onClick={() => acciones.reenviarCorreoEstado(record, envio)}
                />
              </Tooltip>
            )}
            <Tooltip title="Ver insumos y estado general del pedido">
              <ButtonItem
                size="small"
                blanco
                icon={<InfoCircleOutlined />}
                onClick={() => {
                  modales.setModalEstadoGeneralVisible(true);
                  modales.setEstadoGeneralVentaId(record._id);
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <PageHeader
        title="Ventas eCommerce"
        style={{
          border: "1px solid rgb(235, 237, 240)",
          backgroundColor: "white",
          marginBottom: 10,
        }}
        extra={
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <SegmentedItem
              options={[
                { value: "", label: "Todos" },
                ...Object.keys(STATUS_CONFIG).map((estado) => ({
                  value: estado,
                  label: STATUS_CONFIG[estado].label,
                })),
              ]}
              value={estadoFiltro || ""}
              onChange={(val) => {
                const nuevo = val || null;
                setEstadoFiltro(nuevo);
                actualizarFiltrosExternos({ estadoFiltro: nuevo });
              }}
            />
            <div className="header-divider"></div>
            <SegmentedItem
              options={[
                { value: "", label: "Todos" },
                ...ORIGENES_FILTRO.map((o) => ({ value: o.key, label: o.label })),
              ]}
              value={origenFiltro || ""}
              onChange={(val) => {
                const nuevo = val || null;
                setOrigenFiltro(nuevo);
                actualizarFiltrosExternos({ origenFiltro: nuevo });
              }}
            />
          </div>
        }
      />

      {/* Fila 1: filtros. */}
      <SubHeaderItem style={{ marginBottom: 0, borderRadius: "6px 6px 0 0" }}>
        {escuelaActivo && (
          <SelectEscuelasItem
            allowClear
            placeholder="Filtrar por escuela"
            style={{ width: 220 }}
            value={escuelaFiltroId}
            empresaId={empresaId}
            headersToken={headersToken}
            onChange={(val) => {
              const nuevo = val || null;
              setEscuelaFiltroId(nuevo);
              actualizarFiltrosExternos({ escuelaFiltroId: nuevo });
            }}
          />
        )}
        <InputItem
          type="text"
          placeholder="Buscar por folio, cliente o referencia..."
          value={textoFiltroInput}
          onChange={(e) => setTextoFiltroInput(e.target.value)}
          onPressEnter={() => actualizarFiltrosExternos({ textoFiltro: textoFiltroInput || undefined })}
          allowClear
          style={{ width: 260 }}
          prefix={<SearchOutlined />}
        />
        <DatePickerItem
          placeholder="Desde"
          style={{ width: 130 }}
          value={fechaInicioValue}
          onChange={(momentValue) => {
            setFechaInicioValue(momentValue || null);
            actualizarFiltrosExternos({
              fechaInicio: momentValue ? momentValue.format("YYYY-MM-DD") : undefined,
            });
          }}
        />
        <DatePickerItem
          placeholder="Hasta"
          style={{ width: 130 }}
          value={fechaFinValue}
          onChange={(momentValue) => {
            setFechaFinValue(momentValue || null);
            actualizarFiltrosExternos({
              fechaFin: momentValue ? momentValue.format("YYYY-MM-DD") : undefined,
            });
          }}
        />
        <ButtonItem
          key="refresh"
          lila
          onClick={onRefrescar}
          className="botonAgregar"
          icon={<SearchOutlined />}
        />
      </SubHeaderItem>

      <SubHeaderItem style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
        {permisoConfirmarPago && (
          <Tooltip title="Conciliar transferencias por Excel">
            <ButtonItem
              className="botonAgregar"
              verde
              icon={<FileExcelOutlined />}
              onClick={() => modales.setModalConciliarExcelVisible(true)}
            />
          </Tooltip>
        )}
        <Tooltip
          title={
            selectedRowKeys.length > 0
              ? `Imprimir picking de ${selectedRowKeys.length} seleccionado(s)`
              : "Generar picking masivo (por fecha o folio)"
          }
        >
          <ButtonItem
            className="botonAgregar"
            naranja
            icon={<FilePdfOutlined />}
            onClick={abrirModalPicking}
          />
        </Tooltip>
        <Tooltip title="Importar Ventas de Libros">
          <ButtonItem
            className="botonAgregar"
            azul
            icon={<ImportOutlined />}
            onClick={() => history.push("/panel/importarVentasLibros")}
          />
        </Tooltip>

        <div className="header-divider"></div>

        {ESTADOS_ACCION_FIJOS.map((estado) => {
          const habilitado =
            !!infoGrupo &&
            infoGrupo.estadoDestino === estado &&
            !(estado === 2 && selectedRows.length > 1 && !puedeEmpaquetarEnLote);
          return (
            <Tooltip
              key={estado}
              title={
                habilitado
                  ? `Pasar ${selectedRows.length} pedido(s) a "${STATUS_CONFIG[estado].label}"`
                  : "Selecciona uno o más pedidos del mismo tipo de envío y estado para habilitar"
              }
            >
              <ButtonItem
                type="primary"
                disabled={!habilitado}
                icon={STATUS_CONFIG[estado]?.icon}
                {...(habilitado ? { [COLOR_PROP_POR_ESTADO[estado] || "azul"]: true } : {})}
                onClick={() => manejarAvanzarSeleccion(estado)}
              >
                {STATUS_CONFIG[estado].label}
              </ButtonItem>
            </Tooltip>
          );
        })}

        {selectedRowKeys.length > 0 && (
          <>
            <div className="header-divider"></div>
            <Text strong>{selectedRowKeys.length} seleccionado(s)</Text>
            <ButtonItem rojo onClick={limpiarSeleccion}>
              Cancelar selección
            </ButtonItem>
          </>
        )}
      </SubHeaderItem>

      {mensajeSeleccionInvalida && (
        <Alert
          type="warning"
          showIcon
          message={mensajeSeleccionInvalida}
          style={{ marginBottom: 12 }}
          closable
        />
      )}

      <TableItemDinamico
        ref={(ref) => (tableRef.current = ref)}
        onRef={(ref) => (tableRef.current = ref)}
        totalRecords={totalRecords}
        onFetchData={consultarVentasTabla}
        loading={loading}
        size="small"
        dataSource={ventasTabla}
        columns={columns}
        estadosLeyenda={ESTADOS_LEYENDA}
        filterStorageKey={"ventasEcommerceVistaTablaFiltros" + empresaId}
        onClearFilters={() => {
          setEscuelaFiltroId(null);
          setOrigenFiltro(null);
          setEstadoFiltro(null);
          setFechaInicioValue(null);
          setFechaFinValue(null);
          setTextoFiltroInput("");
        }}
        pagination={false}
        rowKey={(record) => `${record._id}-${record.envio?.origen}`}
        rowSelection={rowSelection}
        rowClassName={(record) => `estado-paquete-${record.envio?.estadoPaquete ?? 0}`}
        onRow={(record) => ({
          onDoubleClick: () => history.push("/panel/verVenta", { id: record._id }),
          onContextMenu: (e) => {
            e.preventDefault();
            modales.setModalEstadoGeneralVisible(true);
            modales.setEstadoGeneralVentaId(record._id);
          },
        })}
      />

      <ModalGenerarGuia
        visible={modales.modalGuiaVisible}
        ventaId={modales.selectedVentaId}
        origenKey={modales.selectedOrigenKey}
        onCancel={() => modales.setModalGuiaVisible(false)}
        onSuccess={(datosGuia) => {
          modales.setModalGuiaVisible(false);
          onRefrescar();
          if (datosGuia?.labelUrl) {
            modales.setModalPreviewVisible(true);
            modales.setArchivoPreview({
              url: datosGuia.labelUrl,
              name: `Guia_${modales.selectedVentaId}.pdf`,
              mime: "application/pdf",
            });
          }
        }}
      />
      <ModalGenerarOCDropshipping
        visible={modales.modalOCVisible}
        ventaId={modales.selectedVentaId}
        origenKey={modales.selectedOrigenKey}
        onCancel={() => modales.setModalOCVisible(false)}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalOCVisible(false))}
      />
      <ModalPrevisualizarArchivos
        visible={modales.modalPreviewVisible}
        onClose={() => modales.setModalPreviewVisible(false)}
        file={modales.archivoPreview}
      />
      <ModalProgramarRecoleccion
        visible={modales.modalRecoleccionVisible}
        carrier={modales.recoleccionCarrier}
        origenKey={modales.recoleccionOrigen}
        ventasLocal={ventasParaRecoleccion}
        onCancel={() => modales.setModalRecoleccionVisible(false)}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalRecoleccionVisible(false))}
      />
      <ModalConfirmarTransito
        visible={modales.modalTransitoVisible}
        venta={modales.transitoVenta}
        envio={modales.transitoEnvio}
        origenKey={modales.transitoOrigenKey}
        enviarCorreoDefault={acciones.getEnviarCorreoDefault(4, modales.transitoOrigenKey)}
        onCancel={() => modales.setModalTransitoVisible(false)}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalTransitoVisible(false))}
      />
      <ModalGenerarGuiaManual
        visible={modales.modalGuiaManualVisible}
        ventaId={modales.selectedVentaId}
        origenKey={modales.selectedOrigenKey}
        soloActualizar={modales.soloActualizarEmpaquetado}
        enviarCorreoDefault={acciones.getEnviarCorreoDefault(2, modales.selectedOrigenKey)}
        onCancel={() => {
          modales.setModalGuiaManualVisible(false);
          modales.setSoloActualizarEmpaquetado(false);
        }}
        onSuccess={(datosGuia) => {
          modales.setModalGuiaManualVisible(false);
          onRefrescar();
          if (datosGuia?.labelUrl) {
            modales.setModalPreviewVisible(true);
            modales.setArchivoPreview({
              url: datosGuia.labelUrl,
              name: `Guia_${modales.selectedVentaId}.pdf`,
              mime: "application/pdf",
            });
          }
        }}
      />
      <ModalConfirmarEstadoConCorreo
        visible={modales.modalEstadoCorreoVisible}
        venta={modales.estadoCorreoVenta}
        envio={modales.estadoCorreoEnvio}
        origenKey={modales.estadoCorreoOrigen}
        nuevoEstado={modales.estadoCorreoNuevoEstado}
        enviarCorreoDefault={acciones.getEnviarCorreoDefault(
          modales.estadoCorreoNuevoEstado,
          modales.estadoCorreoOrigen,
        )}
        onCancel={() => modales.setModalEstadoCorreoVisible(false)}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalEstadoCorreoVisible(false))}
      />
      <ModalConfirmarPagoTransferencia
        visible={modales.modalConfirmarTransferenciaVisible}
        venta={modales.ventaAConfirmarTransferencia}
        onCancel={() => modales.setModalConfirmarTransferenciaVisible(false)}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalConfirmarTransferenciaVisible(false))}
      />
      <ModalConciliarTransferenciasExcel
        visible={modales.modalConciliarExcelVisible}
        onCancel={() => cerrarYRefrescar(() => modales.setModalConciliarExcelVisible(false))}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalConciliarExcelVisible(false))}
      />
      <ModalGenerarPickingLote
        visible={modales.modalPickingLoteVisible}
        ventaIds={pickingSeleccionVentaIds}
        origenKey={pickingSeleccionOrigenKey}
        onCancel={() => {
          modales.setModalPickingLoteVisible(false);
          setPickingSeleccionVentaIds(null);
          setPickingSeleccionOrigenKey(null);
        }}
      />
      <ModalConfirmarEmpaquetadoLote
        visible={modalEmpaquetadoLoteVisible}
        ventaIds={selectedRows.map((r) => r._id)}
        origenKey={grupoSeleccion?.origenKey}
        onCancel={() => setModalEmpaquetadoLoteVisible(false)}
        onConfirmar={confirmarEmpaquetadoLote}
      />
      <ModalEstadoGeneralPedido
        visible={modales.modalEstadoGeneralVisible}
        ventaId={modales.estadoGeneralVentaId}
        onCancel={() => {
          modales.setModalEstadoGeneralVisible(false);
          modales.setEstadoGeneralVentaId(null);
        }}
      />
      <ModalConfirmarEmpaquetadoSucursal
        visible={modales.modalEmpaqueSucursalVisible}
        ventaId={modales.selectedVentaId}
        origenKey={modales.selectedOrigenKey}
        soloActualizar={modales.soloActualizarEmpaquetado}
        enviarCorreoDefault={acciones.getEnviarCorreoDefault(2, "entrega_sucursal")}
        onCancel={() => {
          modales.setModalEmpaqueSucursalVisible(false);
          modales.setSoloActualizarEmpaquetado(false);
        }}
        onSuccess={() => cerrarYRefrescar(() => modales.setModalEmpaqueSucursalVisible(false))}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  empresaId: state.empresa.id,
  headersToken: state.user.headersToken,
  escuelaActivo: !!state.empresa.escuela,
  permisoConfirmarPago:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) => valueTodos.permisoId.toString() === "6a28321b2f290af9f3d913e8",
    )?.activado,
});

export default connect(mapStateToProps)(VentasEcommerceTabla);
